import type { ModalFuncProps } from 'antd';
import css from './index.module.scss';
import EfModal from '@/components/UI/Modal';
import { useGlobal } from '@/utils/useGlobal';

export default function Mm100Popup({ visible, onCancel }: ModalFuncProps) {
    const { isMobile, useEffect, useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();

    const facebookConfig: { [key: string]: string } = {
        us: 'https://www.facebook.com/groups/deltaprolaunch',
        de: 'https://www.facebook.com/groups/ecoflowclubdeutsch',
        fr: 'https://www.facebook.com/groups/ecoflowfrancophone',
        kr: 'https://cafe.naver.com/ecoflowkr',
        za: 'https://www.facebook.com/groups/efsouthafrica',
    };
    const facebookUrl = facebookConfig[locale] || facebookConfig['us'];

    const getDataLayer = () => {
        return {
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: t('delta2.join_community'),
        };
    };

    useEffect(() => {
        if (isMobile && visible) {
            document.documentElement.style.overflowY = 'hidden';
        }
        return () => (document.documentElement.style.overflowY = '');
    }, []);

    return (
        <EfModal
            visible={visible}
            onCancel={onCancel}
            width={924}
            className={`${css.popup} GtmModuleData-section`}
            data-section-id={css.popup}
            data-section-title={t('delta2.popupTitle')}
            maskStyle={{ backgroundColor: 'rgba(0, 0, 0, .6)' }}
        >
            <h5 className="popup-title">{t('delta2.popupTitle')}</h5>
            <div className="popup-text">
                {t.rich('delta2.popupContent', {
                    p: (text: string) => <span className="orange">{text}</span>,
                })}
            </div>
            <Link href={facebookUrl} dataLayer={getDataLayer()}>
                <button className="popup-btn">{t('delta2.join_community')}</button>
            </Link>
        </EfModal>
    );
}
